import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { t } from 'i18next';
import { AxiosInstance } from 'axios';
import { AiOutlineClose } from 'react-icons/ai';

import { errorMessageAdapter } from '../../../../adapters';
import { ChatService } from '../../../../services/ChatService';
import { useApi } from '../../../../services/hooks/apiHook';

import { useAuth } from '../../../../store/auth';
import { useMailStore } from '../store/mail.store';
import { errorToast } from '../../../../utils/toasts';

interface SendMessageSectionProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: string;
  placeholder?: string;
}

const SendMessageSection: React.FC<SendMessageSectionProps> = ({ placeholder, ...rest }) => {
  const [message, setMessage] = useState('');
  const [file, setFile] = useState<File | null>(null);
  const [loading, setLoading] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const api: AxiosInstance = useApi();

  const { token } = useAuth();
  const { selectedUser, forceUpdate } = useMailStore();
  const { i18n } = useTranslation();

  const handleSendMessage = async (e: any) => {
    e.preventDefault();
    if (!message && !file) return;
    try {
      setLoading(true);
      await ChatService.send(
        api,
        {
          to: String(selectedUser!.id),
          content: message,
          type: file ? 'file' : 'message',
          file: file ? file : undefined
        },
        {
          headers: {
            'Content-Language': i18n.language,
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${token}`
          }
        }
      );
      setLoading(false);
      setMessage('');
      forceUpdate();
    } catch (e) {
      setLoading(false);
      errorToast(errorMessageAdapter(e));
    }
  };

  function onChangeFile(e: any) {
    setFile(e.target.files[0]);
  }

  function removeFile() {
    fileInputRef.current!.value = '';
    setFile(null);
  }

  return (
    <form className="flex flex-row gap-4 border-t-[2px] border-[#E1E9EF] bg-white px-6 py-4" onSubmit={handleSendMessage}>
      <div className="flex w-full flex-row items-center rounded-lg border-[2px] border-solid border-[#E1E9EF] p-3 transition-all focus-within:border-[#0C1FAA]">
        {file ? null : (
          <input
            className={'h-[44px] w-full px-2 text-base text-[#373D43] outline-none'}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            {...rest}
            placeholder={placeholder}
          ></input>
        )}

        {file ? (
          <div className="flex h-[44px] w-full flex-row items-center gap-2 px-2">
            <AiOutlineClose size={24} color="#0C1FAA" onClick={removeFile} className="cursor-pointer" />
            <span className="text-[#0C1FAA]">{file.name}</span>
          </div>
        ) : null}

        {/* <label>*/}
        {/*  <AiOutlinePaperClip size={30} color="#0C1FAA" className='cursor-pointer'/>*/}
        {/*  <input type='file' className="hidden" onChange={onChangeFile} ref={fileInputRef} {...rest}/>*/}
        {/* </label>*/}
        {/* <AiOutlineSmile size={30} color="#0C1FAA" />*/}
      </div>

      <button
        className="w-48 rounded-lg bg-[#0C1FAA] px-6 py-3 text-base font-semibold text-white transition-all hover:bg-[#0A1888] disabled:bg-slate-400"
        type="submit"
        disabled={loading}
      >
        {loading ? (
          <div className="flex flex-row items-center justify-center gap-2">
            <div className="h-4 w-4 animate-spin rounded-full border-2 border-white"></div>
            <span>Enviando...</span>
          </div>
        ) : (
          <span>{t('labels.lblSendMessage')}</span>
        )}
      </button>
    </form>
  );
};

export { SendMessageSection };
